import { TripProtectionBanner } from '../data-models/trip-protection-banner.interface';

export const TripProtectionBannerMockConfig: TripProtectionBanner = {
  icon: {
    iconPath: '/content/dam/delta-applications/ui-kit/assets/svg/bell-icon.svg',
    altLabel: ''
  },
  tripProtectionBannerLabel:
    'Our records show that you purchased travel insurance for this flight',
  tripProtectionBannerMessage1:
    '<a href="http://www.etravelprotection.com/deltausa/home" target="_blank">Update your policy online <span class="sr-only">opens in new tab</span></a> or contact Allianz Global Assistance at (800) 419-8016 for more information.',
  tripProtectionBannerMessage2: '',
  tripProtectionTitle: 'Trip Protection'
};
